import { useEffect, useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/auth";

export function useDashboardMoneyVisibility(enabled = true) {
  const { user, store } = useAuth();
  const accountKey = `${user?.id ?? "anonymous"}:${store?.id ?? "none"}:${user?.role ?? ""}`;
  const [visibility, setVisibility] = useState<{ accountKey: string; visible: boolean } | null>(null);
  const visible = enabled && visibility?.accountKey === accountKey && visibility.visible;

  useEffect(() => {
    setVisibility(null);
  }, [accountKey]);

  return {
    moneyVisible: visible,
    toggleMoneyVisibility: () => setVisibility({ accountKey, visible: !visible }),
    maskMoney: (formattedAmount: string) => visible ? formattedAmount : "####",
  };
}

export function DashboardMoneyToggle({
  visible,
  onToggle,
}: {
  visible: boolean;
  onToggle: () => void;
}) {
  return (
    <Button
      variant="outline"
      size="sm"
      className="gap-2"
      aria-label={visible ? "Hide dashboard amounts" : "Reveal dashboard amounts"}
      onClick={onToggle}
    >
      {visible ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
      {visible ? "Hide amounts" : "Show amounts"}
    </Button>
  );
}